<!-- 采购收货列表 -->
<template>
   <div class='page_content'>
      <!-- 触发弹窗 -->
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <purchaseReceivingAction v-if="showStatus" ref="purchaseReceivingAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></purchaseReceivingAction>
      </el-drawer>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
            </vSearch>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" @selection-change="handleSelectionChange" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                   @current-change="handleCurrentChange" highlight-current-row>
            <el-table-column type="selection" width="55"></el-table-column>
            <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
               <el-table-column align="center" v-if="tableValye.isShow == 1" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField" :label="tableValye.showField" :min-width="tableValye.fieldWeight">
                  <template slot-scope="scope">
                     <span v-if="tableValye.fieldType == 'date'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                     </span>
                     <span v-else-if="tableValye.fieldType == 'dateTime'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
                     </span>
                     <span v-else-if="tableValye.isRift == 1">
                        <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                     </span>
                     <el-tag size="mini" v-else-if="tableValye.entityField == 'psrgmState'">
                        {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psrgmState) }}</el-tag>
                     <span v-else>
                        {{ scope.row[tableValye.entityField] }}
                     </span>
                  </template>
               </el-table-column>
            </template>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="getSeData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";

import purchaseReceivingAction from "@/components/purchaseReceivingAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      purchaseReceivingAction
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         seTitle: "",
         DialogVisible: false,
         seWidth: "",
         seId: "",
         getRequestData: {
            psrgmPurchaser: "",
            psrgmBuycus: "", // 购进单位
            psrgmBuycusName: "", // 购进单位名称
            smId: "",
            smName: "",
            page: 1,
            rows: 30,
            start:
               new Date(new Date().toLocaleDateString()).getTime() -
               31 * 24 * 3600 * 1000,
            end:
               new Date(new Date().toLocaleDateString()).getTime() +
               24 * 60 * 60 * 1000 -
               1,
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],

         pageShowData: [],
         formDataList: [],
         selectData: [],
         selectedDetailsDataIndex: "",
         showStatus: false,
         actionData: [],
         disbleshow: true,
         parentSearchData: {},
         sField: '', //赋值字段
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.psrgmBuycusName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.psrgmBuycus = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      handleSelectionChange(val) {
         this.selectData = val
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      // 子组件触发
      drawerCancel(e) {
         this.showStatus = false;
         if (e == 1) this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         //    console.log(orderId)
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      openSearch({ sId, index, type, sField }) {
         this.seId = sId;
         this.DialogVisible = true;
         this.sField = sField
         this.parentSearchData[type] = this.getRequestData[type]
      },
      getSeData(val) {
         this.paramValue(val)
         this.DialogVisible = false;
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      isShowData(name, value) {
         console.log(name);
         switch (name) {
            case "psrgmBuycus":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.getRequestData.psrgmBuycus = dataInfo.smId;
                  this.getRequestData.psrgmBuycusName = dataInfo.smName;
               }
               break;
            default:
               this.sendDataInfo[name] = value;
         }
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         if (responseData.status == 200) {
            this.pageShowData = responseData.result
            this.formDataList = this.pageShowData.jurFormVoList
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getButtonList();
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      clear(val) {
         if (val) {
            var arr = val.split(",")
            arr.forEach(item => {
               this.$set(this.getRequestData, item, "")
            })
         }
      },
      handleCurrentChange(val) {
         if (val == undefined) {
            return
         }
         if (val.psrgmState != 0) {
            this.disbleshow = false;
         } else {
            this.disbleshow = true;
         }
         console.log(this.disbleshow);
      },
      // 按钮操作动作集合 chen
      actionSet(actionData) {
         if (this.disbleshow == false) {
            this.$message.error("此状态不能进行此操作");
         } else {
            switch (actionData.actionType) {
               case 0:
                  this.showStatus = true;
                  this.actionData = {
                     cate: 0,
                     formData: this.formDataList,
                     oldData: "",
                     orderId: "",
                     printSouce: "",
                     printJurId: "",
                  };
                  break;
               case 1:
                  if (this.selectData.length != 1) {
                     this.$message({
                        message: "请先选中一条要操作的数据",
                        type: "error",
                     });
                     return false;
                  }
                  var dataInfo = this.selectData[0]
                  this.showStatus = true;
                  this.actionData = {
                     cate: 1,
                     formData: this.formDataList,
                     oldData: dataInfo,
                     orderId: dataInfo.psrgmId,
                     printSouce: "",
                     printJurId: "",
                  };
                  break;
               case 2:
                  this.delDataAction();
                  break;
               case 3:
                  this.submitPurchaseReceipt();
                  break;
            }
         }
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },

      // 获取数据列表
      async getDataList() {
         if (this.getRequestData.smName == "") {
            this.getRequestData.smId = "";
         }
         let responseData = await this.$http.getPurchaseReceipt(
            this.getRequestData
         );
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            console.log(this.returnData.list[0])
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDetailsDataIndex = "";

         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 提交审核
      async submitPurchaseReceipt() {
         if (this.selectData.length == 0) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         var delData = {
            ids: this.selectData.map(item => item.psrgmId),
         };
         let responseData = await this.$http.submitPurchaseReceipt(delData);
         if (responseData.status == 200) {
            this.$message({
               type: "success",
               message: "操作成功!",
            });
            this.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 删除数据
      delDataAction() {
         if (this.selectData.length != 1) {
            this.$message({
               message: "请先选中一条要操作的数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.selectData[0];
         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.psrgmId],
               };
               let responseData = await this.$http.delPurchaseReceipt(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
//获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      // 初始化时间
      initTime() {
         this.getRequestData.start = this.$common.getStartTime()
         this.getRequestData.end = this.$common.getEndTime()
      }
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
      this.initTime()
      // this.getDataList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
</style>